import { calculateRouteOverlap, canDriverReachPassenger, getPassengerRoute } from './driverUtils';

export async function findMatchingPassengers(passengers, driver, driverRoute) {
    if (!driver || !driverRoute?.length) return [];

    const matches = await Promise.all(passengers.map(async passenger => {
        try {
            const passengerRoute = await getPassengerRoute(passenger);
            if (!passengerRoute.length) return null;
            const overlapPercentage = calculateRouteOverlap(driverRoute, passengerRoute);
            const canReach = await canDriverReachPassenger(driver, passenger);
            return overlapPercentage > 50 && canReach
                ? { ...passenger, overlapPercentage, canReachIn10Min: canReach }
                : null;
        } catch (error) {
            console.error('Error matching passenger:', error);
            return null;
        }
    }));
    return matches.filter(Boolean);
}
